import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {CssRender} from '../message/CssRender';

export class CssRenderWrapper extends BaseWrapper<CssRender, BasicCriteria, BasicScenario>  {}

